import ajax from '../exports/ajax'
import ajax_load_more from '../exports/ajax_load_more'

$(document).ready(() => {
  // INFINITE SCROLL AND LAZY LOADING EFFECT
  // Infinite scroll - simulate load more button
  function initializeInfiniteScroll() {
    let isLoading = false;
    const $filteredListingWrapper = $('.filtered-listing-games-wrapper');
    const oneQuarterHeightOffset = $filteredListingWrapper.outerHeight() - 200;

    function loadMoreGames() {
      if (isLoading) return;
      isLoading = true;
      const $loadMoreButton = $('.c-btn-load-more.filter-load-more');
      if ($loadMoreButton.length) {
        $('.custom-loader_load_more').addClass('active');
        // Simulate a click on the load more button
        $loadMoreButton.trigger('click');
      } else {
        console.log('No more games to load!');
      }
    }

    function checkVisible(elm, threshold, mode) {
      threshold = threshold || 0;
      mode = mode || 'visible';

      var rect = elm.getBoundingClientRect();
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      var above = rect.bottom - threshold < 0;
      var below = rect.top - viewHeight + threshold >= 0;

      return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
    }

    function animateVisibleElements() {
      var windowHeight = $(window).height();
      var windowMiddle = $(window).scrollTop() + windowHeight;

      var $boxElement = $('.box');

      // Make sure the first 3 boxes are always visible
      $boxElement.slice(0, 6).addClass('visible');

      // Apply fade-in effect only to the remaining boxes
      $boxElement.slice(6).each(function() {
        var elementTop = $(this).offset().top;

        // If the element is below the middle of the screen, reapply the fade-in effect
        if (elementTop > windowMiddle) {
          $(this).removeClass('visible');
          if (!$(this).hasClass('fade-in')) {
            $(this).addClass('fade-in');
          }
        }

        // If the element is visible in the viewport, add the visible class
        if (checkVisible(this, 50)) {
          $(this).addClass('visible');
        }
      });
    }

    $(window).on('scroll resize', function() {
      animateVisibleElements();

      if ($(window).scrollTop() + $(window).height() >= $filteredListingWrapper.offset().top + $filteredListingWrapper.outerHeight() - oneQuarterHeightOffset) {
        if ($.active === 0) {
          loadMoreGames();
        }
      }
    });

    // Hide the load more button
    $('.c-btn-load-more.filter-load-more').hide();

    // Add fade-in animation class to new elements that are not initially visible
    $('.box').each(function() {
      if (!checkVisible(this, 50)) {
        $(this).addClass('fade-in');
      }
    });

    animateVisibleElements();

    // Listener for AJAX completion
    $(document).ajaxComplete(function(event, xhr, settings) {
      isLoading = false;
      const $loadMoreButton = $('.c-btn-load-more.filter-load-more');
      
      if ($loadMoreButton.length && $('.custom-loader_load_more').hasClass('active')) {
        // Increased timeout for better loader visibility
        setTimeout(function() {
          $('.custom-loader_load_more').removeClass('active');
        }, 2000);  // Adjust the timeout here
      } else {
        $('.custom-loader_load_more').removeClass('active');
      }
      $loadMoreButton.hide();

      // Add fade-in animation class to new elements
      $('.box').not('.fade-in').each(function() {
        if (!checkVisible(this, 50)) {
          $(this).addClass('fade-in');
        }
      });
      animateVisibleElements();
    });

    // Event listeners for resetting infinite scroll
    $('.js-order-list, .js-order-thumb').on('click', function() {
      resetInfiniteScroll();
    });

    function resetInfiniteScroll() {
      var $boxElement = $('.box');
      // Remove fade-in and visible classes
      $boxElement.removeClass('fade-in visible');

      // Make sure the first 3 boxes are always visible
      $boxElement.slice(0, 6).addClass('visible');

      // Re-add fade-in class and trigger scroll event to animate elements
      $boxElement.slice(6).each(function() {
        if (!checkVisible(this, 50)) {
          $(this).addClass('fade-in');
        }
      });
      $(window).trigger('scroll');
    }
  }

  if ($('.filtered-listing-games-wrapper').length) {
    initializeInfiniteScroll();
  }
  // INFINITE SCROLL AND LAZY LOADING EFFECT - END
});


let tempGameInstance = '';
const getCurrentUrl = new URL(window.location.href);
const isHomePage = getCurrentUrl.pathname == '/';
const isNotHomePage = getCurrentUrl.pathname !== '/';
const isRoadmapPage = getCurrentUrl.pathname == '/roadmap/';
const fixedWidthFilterMobile = 1025;

$(document).ready(() => {

  //Temporary fix for back to the page
  if (isRoadmapPage) {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }

  delIdGameSessionStorage();
  filter();

  if (!getItemSessionStorage('filTerms')) {
    removeCookie('gamesCookieCount');
  }
});

const removeSessionStorageItems = (items) => {
  items.forEach(selector => {
    sessionStorage.removeItem(selector);
  });
}

const getItemSessionStorage = (item) => {
  return sessionStorage.getItem(item);
}

const setItemSessionStorage = (key, value) => {
  return sessionStorage.setItem(key, JSON.stringify(value));
}

const delIdGameSessionStorage = () => {
  var currentUrl = window.location.href;

  // Array of strings to check in the URL
  var stringsToCheck = ['slot-games', 'instant-game', 'social-game'];
  var isStringIncluded = stringsToCheck.some(function (string) {
    return currentUrl.includes(string);
  });
  if (!isStringIncluded && isNotHomePage) {
    removeSessionStorageItems(['id-game']);
  }
}
delIdGameSessionStorage();

const filter = () => {
  return new Promise((resolve, reject) => {
    if (!$('.games-listing-elements')) {
      console.log('No games found on this page.')
      return false;
    }
    if (isHomePage || isRoadmapPage) {
      //filter_body('click', '.filter-main-games-ch', true);
      filter_body('click', '.filter-load-more', true);
    }
    resolve();
  });
}

const getIDofTheGame = () => {
  const selectors = ['.game-listing-box a'];

  selectors.forEach(selector => {
    $(selector).on("click", function () {
      const parentId = $(this).closest('.game-listing-box').attr("id");

      // Check if parentId is not undefined before proceeding
      if (parentId !== undefined && isHomePage) {
        setItemSessionStorage("id-game", parentId);
      }
    });
  });
}
getIDofTheGame();

const delSessionStorageIdGame = () => {
  const selectors = ['ul.main-nav li', '.mobile-nav .li', '#header .logo'];
  selectors.forEach(selector => {
    $(selector).on("click", function () {
      removeSessionStorageItems(sessionStorageItems);
      sessionStorage.removeItem('id-game');
    });
  });
}
delSessionStorageIdGame();


/**
 *
 * @param eventType
 * @param el
 * @param bypassSearch
 */
function filter_body(eventType, el, bypassSearch = false) {
  let debounceTimeout;
  let hasText = false;

  $(document).on(eventType, el, function () {
    let thisElement = $(this);
    let getEventType = eventType;

    const runFilterLogic = function () {
      let getAction = thisElement.data('action');
      var setAction;
      if (getAction == 'filter_load_more_ajax') {
        setAction = 'filter_load_more_ajax';
      } else if (getAction == 'filter_game_label_ajax') {
        setAction = 'filter_game_label_ajax';
      } else if (getAction == 'filter_load_more_roadmap_ajax') {
        setAction = 'filter_load_more_roadmap_ajax';
      } else if (getAction == 'filter_jackpot_selection_ajax') {
        setAction = 'filter_jackpot_selection_ajax';
      } else if (getAction == 'filter_last_modified_ajax') {
        setAction = 'filter_last_modified_ajax';
      } else {
        setAction = 'filter_labels_or_cpt_ajax';
      }

      let search = (thisElement.data('value-label') !== undefined && thisElement.data('value-label').length) ? thisElement.data('value-label') : thisElement.val(),
        action = setAction,
        searchEl = thisElement.attr('name') !== undefined ? thisElement.attr('name') : thisElement.data('name'),
        gameInstance = thisElement.parents('.main-filters-ch').length ? thisElement.parents('.main-filters-ch') : thisElement;

      if (thisElement.data('game-instance') !== undefined && !thisElement.hasClass('btn')) {
        $('.filter-main-games-ch').removeClass('current')
        thisElement.addClass('current')
        tempGameInstance = thisElement.data('game-instance');
      }

      if (getItemSessionStorage('id-game') !== null && getItemSessionStorage('id-game') !== undefined && getItemSessionStorage('id-game') !== "") {
        // Delete the sessionStorage with key 'id-game'
        sessionStorage.removeItem('id-game');
      }

      // Remove cookie - set the expiration date to a past date to delete the cookie
      document.cookie = 'gamesCookieCount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

      //Get General values for the action
      var getData = {
        [searchEl]: search,
        action: action,
      }

      //Get Roadmap values for the action
      var getDataRoadmap = {
        [searchEl]: search,
        action: action,
        game_instance: 'roadmap_game',
      }

      //Change the selector input filter depending of the screen < 1025
      var getSearchInputVal = $('#search_game').val();
      var getSearchInputValMobile = $('.mobile-filter-pop .input.filter-search-slot-games').val();
      var getSearchCheck;

      //Check if the page is not Roadmap and get the value from the input, otherwise return getSearchCheck empty
      if (document.location.href.indexOf('roadmap') === -1) {
        if (document.documentElement.clientWidth < fixedWidthFilterMobile) {
          getSearchCheck = getSearchInputValMobile;
        } else {
          getSearchCheck = getSearchInputVal;
        }
      } else {
        getSearchCheck = '';
      }

      //Check if the page is not Roadmap
      if (document.location.href.indexOf('roadmap') === -1 && getItemSessionStorage('search_game') !== 'undefined') {
        var checkSearchGames = JSON.parse(getItemSessionStorage('search_game'));
      } else {
        checkSearchGames = '';
      }

      //Get data from sessionStorage if it's not empty, otherwise get diractly data directly from getData (action values from the attributes in the front)
      var data = {
        action: action,
        'search_game': getSearchCheck,
        'game_instance': tempGameInstance.length ? tempGameInstance : getItemSessionStorage('game_instance') !== null ? JSON.parse(getItemSessionStorage('game_instance')) : 'all_games',
        'jackpot_selection': getData.jackpot_selection == null || typeof getData.jackpot_selection == 'undefined' ? JSON.parse(getItemSessionStorage('jackpot_selection')) : getData.jackpot_selection,
        'certified_market': getData.certified_market == null || typeof getData.certified_market == 'undefined' ? JSON.parse(getItemSessionStorage('certified_market')) : getData.certified_market,
        'category': getData.category == null || typeof getData.category == 'undefined' ? JSON.parse(getItemSessionStorage('category')) : getData.category,
        'social_games_main_cpt': 0,
        'load_more': getData.load_more,
        'game_ids': getData.game_ids,
        'label': getData.label == null || typeof getData.label == 'undefined' ? JSON.parse(getItemSessionStorage('label')) : getData.label,
        'post_games': 30
      }

      //Set general filTerms sessionStorage object if the URL is the homepage
      if (isHomePage) {
        var gameIds = $(".c-btn-load-more").data("game-ids");

        if (gameIds && (eventType === 'click' && thisElement.hasClass('filter-load-more'))) {
          var idArray = gameIds.split(",");
          var idCount = idArray.length + 29;
          document.cookie = 'gamesCookieCount=' + idCount + '; path=/';
        }

        setItemSessionStorage("filTerms", data);

        if (typeof data.game_instance !== 'undefined') {
          setItemSessionStorage("game_instance", data.game_instance);
        }
      }

      //Fix for jackpot load more button
      if (window.location.href.includes('jackpot')) {

        //Get the post id from the body classes
        var bodyClass = $('body').attr('class');
        // Use a regular expression to extract the numeric part
        var postIdMatch = bodyClass.match(/postid-(\d+)/);

        // Check if there is a match
        if (postIdMatch && postIdMatch.length === 2) {
          // Extracted numeric part
          var getJackPotTypeID = postIdMatch[1];
        } else {
          console.log('Jackpot ID not found!');
        }

        data = {
          action: action,
          'search_game': '',
          'game_instance': 'all_games',
          'jackpot_selection': getJackPotTypeID,
          'certified_market': '',
          'category': '',
          'social_games_main_cpt': 0,
          'load_more': getData.load_more,
          'game_ids': getData.game_ids,
          'label': '',
          'sort_by': 'release_date_desc',
        }
      }

      if (search.length > 0) {
        hasText = true;
      }

      //Get search input value if the value is bigger than 3 symbols, and setItem of search_game in sessionStorage
      if (search.length >= 2 || bypassSearch || (search.length === 0 && hasText)) {
        if (isHomePage) {
          if (document.documentElement.clientWidth < fixedWidthFilterMobile) {
            setItemSessionStorage("search_game", getSearchInputValMobile);
          } else {
            setItemSessionStorage("search_game", getSearchInputVal);
          }

          if (typeof getData.jackpot_selection !== 'undefined') {
            setItemSessionStorage("jackpot_selection", getData.jackpot_selection);
          }

          if (typeof getData.certified_market !== 'undefined') {
            setItemSessionStorage("certified_market", getData.certified_market);
          }

          if (typeof getData.label !== 'undefined') {
            setItemSessionStorage("label", getData.label);
          }

          if (typeof getData.category !== 'undefined') {
            setItemSessionStorage("category", getData.category);
          }
        }
        //this is for loader to not set backg round shadow
        if (searchEl === 'search_game') {
          localStorage.setItem('showLoader', 'false')
        }

        //If the page is not Roadmap get saveChanges var if it is get getDataRoadmap var for data ajax request 
        if (document.location.href.indexOf('roadmap') === -1) {
          //var getSearchData = $.extend(saveChanges, getAjaxData(thisElement, true));
          var getSearchData = $.extend(getAjaxData(thisElement, true), data);

          if (action == 'filter_load_more_ajax' || action == 'filter_load_more_roadmap_ajax') {
            filterAjaxBodyLoadMore('POST', getSearchData, $('.main-games-ch'));
          } else {
            filterAjaxBody('POST', getSearchData, $('.main-games-ch'));
          }

        } else {
          var getSearchData = $.extend(getDataRoadmap, getAjaxData(thisElement, true));
          if (action == 'filter_load_more_ajax' || action == 'filter_load_more_roadmap_ajax') {
            filterAjaxBodyLoadMore('POST', getSearchData, $('.main-games-ch'));
          } else {
            filterAjaxBody('POST', getSearchData, $('.main-games-ch'));
          }
        }
      }

      if (search.length === 0) {
        hasText = false;
      }

    }

    //Add timeout for search input
    if (getEventType.includes('keyup') || eventType.includes('input')) {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        runFilterLogic();
      }, 300);
    } else {
      runFilterLogic();
    }
  });

}


// On change jackpot type select input
$(".filter-jackpot-selection").parent().on("change", function () {
  setItemSessionStorage("type_game", $('#select2-jackpot_selection-container').text());
});

// On change certified market select input
$(".filter-certified-market").parent().on("change", function () {
  setItemSessionStorage("certified_text", $('#select2-certified_market-container').text());
});

// On change label select input
$(".filter-label").parent().on("change", function () {
  setItemSessionStorage("label_text", $('#select2-label-container').text());
});

// On change category filter input
$(".filter-category").parent().on("change", function () {
  setItemSessionStorage("category_text", $('#select2-category-container').text());
});

//GRID VIEW CHANGES

// if (document.documentElement.clientWidth > fixedWidthFilterMobile) {
//   // On change category filter input
//     $(".js-order-thumb").on("click", function () {
//       setItemSessionStorage("grid_filter", 'thumb');
//     });
//   } 
  
  $(".js-order-list").on("click", function () {
      setItemSessionStorage("grid_filter", 'list');
  });

  $(".js-order-thumb").on("click", function () {
    sessionStorage.removeItem("grid_filter");
});

//Get and change the text in the filters inputs if sessionStorage is saved
jQuery(function () {
  const getFiltersTextFromSessionStorage = () => {
      if(isHomePage) {
        if (getItemSessionStorage('type_game') !== null) {
          $('span#select2-jackpot_selection-container').text(JSON.parse(getItemSessionStorage('type_game')));
        }
      
        if (getItemSessionStorage('label_text') !== null) {
          $('span#select2-label-container').text(JSON.parse(getItemSessionStorage('label_text')));
        }
      
        if (getItemSessionStorage('certified_text') !== null) {
          $('span#select2-certified_market-container').text(JSON.parse(getItemSessionStorage('certified_text')));
        }
      
        if (getItemSessionStorage('category_text') !== null) {
          $('span#select2-category-container').text(JSON.parse(getItemSessionStorage('category_text')));
        }
      
        let gameInstanceCheck = JSON.parse(getItemSessionStorage('game_instance'));
        if (getItemSessionStorage('trigger_all_games') == null && gameInstanceCheck == 'all_games') {
          $(".main-filters-ch .top p span").text('Type of Game');
        }
      }
  }
  getFiltersTextFromSessionStorage();
  $(window).on('resize', function () {
    getFiltersTextFromSessionStorage();
  });

  if (getItemSessionStorage('grid_filter') !== null) {
    $('.js-order-list').addClass('current');
    $('.js-order-thumb').removeClass('current');
    $('.main-games-ch').removeClass('thumb');
    $('.main-games-ch').addClass('list');
  }

  var screenWidth = window.innerWidth;

  // Check if the screen width is smaller than 820px
  if(isRoadmapPage) {
    if (screenWidth < 820) {
      $('.main-games-ch').removeClass('list');
    } else {
      $('.main-games-ch').addClass('list');
    }
  }  


  if (document.documentElement.clientWidth < fixedWidthFilterMobile) {
    sessionStorage.removeItem("grid_filter");
  }

});

//Check sessionStorage and get the text from the type game input
$(document).one('ready', function () {
  //scrollToTheGame();
  if (getItemSessionStorage('search_game') !== 'undefined') {
    $('#search_game').val(JSON.parse(getItemSessionStorage('search_game')));

    $('.mobile-filter-pop .input.filter-search-slot-games').val(JSON.parse(getItemSessionStorage('search_game')));
  }

  let gameInstanceCheck = JSON.parse(getItemSessionStorage('game_instance'));

  if (gameInstanceCheck == 'all_games') {
    $('.filter-main-games-ch').removeClass('current');
    $('.filter-main-games-ch[data-game-instance="all_games"]').addClass('current');
    $('.filters-row .top p span').text('Type of Game');
  } else if (gameInstanceCheck == 'slot_games') {
    $('.filter-main-games-ch').removeClass('current');
    $('.filter-main-games-ch[data-game-instance="slot_games"]').addClass('current');
  } else if (gameInstanceCheck == 'instant_games') {
    $('.filter-main-games-ch').removeClass('current');
    $('.filter-main-games-ch[data-game-instance="instant_games"]').addClass('current');
  } else if (gameInstanceCheck == 'social_games') {
    $('.filter-main-games-ch').removeClass('current');
    $('.filter-main-games-ch[data-game-instance="social_games"]').addClass('current');
  }
  //Get text type of game filter
  if (gameInstanceCheck !== null) {
    var myVar = $(".container .filters-row .custom-tab .filter-main-games-ch.current p").text();
    $('.games-listing-elements .top p span').text(myVar);
    var myVarMobile = $(".mobile-filter-pop .main-filters-ch .filter-main-games-ch.current p").text();
    $('.mobile-filter-pop .top p span').text(myVarMobile);
  }

  //Remove and Add select class to the filters
  const removeClassSelectFilters = (arg) => {
    $(arg).removeClass('select2-results__option--selected');
    $(arg).removeClass('select2-results__option--highlighted');
  }

  const addClassSelectFilters = (arg) => {
    $(arg).addClass('select2-results__option--selected');
    $(arg).addClass('select2-results__option--highlighted');
  }

  //Jackpot type
  $(document).on("click", $(".filter-jackpot-selection").parent(), function () {
    if (getItemSessionStorage('type_game') !== null) {
      $('.select2-selection.select2-selection--single span#select2-jackpot_selection-container').text(JSON.parse(getItemSessionStorage('type_game')));

      $("ul#select2-jackpot_selection-results li").each(function (index) {
        removeClassSelectFilters(this);

        if ($(this).text() == JSON.parse(getItemSessionStorage('type_game'))) {
          addClassSelectFilters(this);
        }
      });
    }
  });

  //Certified market
  $(document).on("click", $(".filter-certified-market").parent(), function () {
    if (getItemSessionStorage('certified_text') !== null) {
      $('.select2-selection.select2-selection--single span#select2-certified-market-container').text(JSON.parse(getItemSessionStorage('certified_text')));

      $("ul#select2-certified_market-results li").each(function (index) {
        removeClassSelectFilters(this);

        if ($(this).text() == JSON.parse(getItemSessionStorage('certified_text'))) {
          addClassSelectFilters(this);
        }
      });

    }
  });

  //Label
  $(document).on("click", $(".filter-label").parent(), function () {
    if (getItemSessionStorage('label_text') !== null) {
      $('.select2-selection.select2-selection--single span#select2-label-container').text(JSON.parse(getItemSessionStorage('label_text')));

      $("ul#select2-label-results li").each(function (index) {
        removeClassSelectFilters(this);

        if ($(this).text() == JSON.parse(getItemSessionStorage('label_text'))) {
          addClassSelectFilters(this);
        }
      });

    }
  });

  //Category type
  $(document).on("click", $(".filter-category").parent(), function () {
    if (getItemSessionStorage('category_text') !== null) {
      $('.select2-selection.select2-selection--single span#select2-category-container').text(JSON.parse(getItemSessionStorage('category_text')));

      $("ul#select2-category-results li").each(function (index) {
        removeClassSelectFilters(this);

        if ($(this).text() == JSON.parse(getItemSessionStorage('category_text'))) {
          addClassSelectFilters(this);
        }
      });
    }
  });

});

function removeCookie(cookieName) {
  document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

//Clear filters on click reset filter icon
const sessionStorageItems = [ "filTerms", "action", 'game_instance', 'jackpot_selection', 'certified_market', 'certified_text', 'category', 'search_game', 'type_game', 'category_text', 'label', 'label_text', 'trigger_all_games', 'id-game' , 'grid_filter'];
$(document).on("click", ".js-reset-filter.img-wrapper, .js-close-filters.img-wrapper", function () {
  removeSessionStorageItems(sessionStorageItems);
  removeCookie('gamesCookieCount');
});

$('.filter-main-games-ch[data-game-instance="all_games"]').on("click", function () {
  setItemSessionStorage("trigger_all_games", 'trigger_all_games');
});

//On click remove trigger_all_games sessionStorage if the instance is not all_games
$('.filter-main-games-ch[data-game-instance="slot_games"], .filter-main-games-ch[data-game-instance="instant_games"], .filter-main-games-ch[data-game-instance="social_games"]').on("click", function () {
  removeSessionStorageItems(['trigger_all_games']);
});

/**
 *
 * @param method
 * @param data
 * @param el
 */
function filterAjaxBody(method, data, el) {
  ajax(method, data, function (response) {
    if (response.success === true) {
      el.find('.filter-load-more').parent().remove()
      if (response.data.load_more === true) {
        el.append(response.data.view);
        if ($('.box').length) {
          $('.no-results').text('NO MORE RESULTS');
        }
      } else {
        el.html(response.data.view);
      }
      getIDofTheGame();
      gameCounter();
    }
  })
}

/**
 *
 * @param method
 * @param data
 * @param el
 */
function filterAjaxBodyLoadMore(method, data, el) {
  ajax_load_more(method, data, function (response) {
    if (response.success === true) {
      el.find('.filter-load-more').parent().remove()
      if (response.data.load_more === true) {
        el.append(response.data.view)
      } else {
        el.html(response.data.view);
      }
      getIDofTheGame();
      gameCounter();
    }
  })
}

/**
 *
 * @param thisEl
 * @param onlyValues
 * @returns {*}
 */
function getAjaxData(thisEl, onlyValues = false) {
  let elData = {},
    currentInput,
    elsFilters = thisEl.parents('.main-filters-ch').find('.filter-wrapper-ch'),
    elsLabels = thisEl.parents('.container').find('.main-filters-ch').find('.filter-wrapper-ch'),
    els = elsFilters.length ? elsFilters : elsLabels,
    count = 0;

  if (thisEl.parent().hasClass('filter-wrapper-ch')) {
    thisEl.parents('.container').find('.tabs-wrapper').find('li').each(function (index, value) {
      if ($(value).hasClass('current')) {
        let elName = $(value).data('name');
        elData[elName] = $(value).data('value-label')
      }
    })
  }


  if (thisEl.data('next-page') !== undefined) {
    elData.load_more = thisEl.data('next-page');
    elData.game_ids = thisEl.data('game-ids');
    elData.is_sorting = thisEl.data('game-is-sorting');
  }

  els.each(function (index, value) {
    currentInput = $(value).find(':input');

    if (currentInput !== null && currentInput.length) {
      currentInput = $(value).find(':input');

      let elName = currentInput.attr('name'),
        elAction = currentInput.data('action'),
        parsedIndex = (count === 0) ? 'action' : 'action_' + index;

      elData[elName] = currentInput.val();
      if (!onlyValues) {
        elData[parsedIndex] = elAction;
        count++;
      }
    }
  });

  if (thisEl.parents().find('.filter-main-games-ch.current') !== undefined) {
    elData['label_taxonomy'] = $(thisEl.parents().find('.filter-main-games-ch.current')[0]).data('value-label');
  }

  return elData;
}

const checkForFiltersSessionStorage = () => {
  if (document.location.href.indexOf('roadmap') === -1) {
    if (sessionStorage.hasOwnProperty("filTerms") && !window.location.href.includes('jackpot') && isHomePage) {
      var serializedObj = getItemSessionStorage('filTerms');
      var obj = JSON.parse(serializedObj);

      let saveTabs = {
        'action': 'filter_labels_or_cpt_ajax',
        'search_game': (getItemSessionStorage('search_game') !== null || getItemSessionStorage('search_game') !== 'undefind') ? JSON.parse(getItemSessionStorage('search_game')) : obj.search_game,
        'game_instance': obj.game_instance,
        'jackpot_selection': obj.jackpot_selection = (typeof obj.jackpot_selection !== "undefined") ? obj.jackpot_selection : null,
        'certified_market': obj.certified_market = (typeof obj.certified_market !== "undefined") ? obj.certified_market : null,
        'category': obj.category = (typeof obj.category !== "undefined") ? obj.category : null,
        'social_games_main_cpt': 0,
        'label': obj.label,

      }
      saveTabs = $.extend(saveTabs, getAjaxData($(this), true));
      filterAjaxBody('POST', saveTabs, $('.main-games-ch'));
    }
  }
}
checkForFiltersSessionStorage();

function gameCounter() {
  var gameCountDiv = document.getElementById('gameCount');
    if (gameCountDiv) {
        var h2Elements = gameCountDiv.getElementsByTagName('h2');
        if (h2Elements.length) {
            var sourceContent = document.getElementById('gameCountNumber') ? document.getElementById('gameCountNumber').innerHTML : '';
            h2Elements[0].innerHTML = sourceContent;
        }
    }
  }
gameCounter();

const filterOnEvent = () => {
  return new Promise((resolve, reject) => {
    if (!$('.games-listing-elements')) {
      console.log('No games found on this page.')
      return false;
    }
    if (isHomePage || isRoadmapPage) {
      filter_body('keyup input', '.filter-search-slot-games');
      filter_body('change', '.filter-jackpot-selection', true);
      filter_body('change', '.filter-certified-market', true);
      filter_body('change', '.filter-category', true);
      filter_body('change', '.filter-label', true);
      filter_body('change', '.filter-sort-by', true);
      filter_body('click', '.filter-main-games-ch', true);

    } else if (window.location.href.includes('jackpot')) {
      filter_body('click', '.filter-load-more', true);
    }
    resolve();
  });
}
filterOnEvent();


// WEBPACK FOOTER //
// ./scripts/components/clientHubFilters.js